import React from 'react';
import { Award } from 'lucide-react';
import { Panel, Empty } from './HeadlineCards';

const Score = ({ v, n }) => (v == null
  ? <span className="text-zinc-600">—</span>
  : <span className={v >= 70 ? 'text-teal-300' : v >= 50 ? 'text-amber-300' : 'text-rose-300'}>{v}%<span className="text-zinc-600 text-[10px] ml-1">({n})</span></span>);

const Table = ({ head, children }) => (
  <div className="overflow-x-auto max-h-80">
    <table className="w-full text-sm">
      <thead className="sticky top-0 bg-zinc-950">
        <tr>{head.map((h, i) => <th key={h} className={`py-2 text-[11px] uppercase tracking-wide text-zinc-500 font-medium ${i ? 'text-right' : 'text-left'}`}>{h}</th>)}</tr>
      </thead>
      <tbody className="divide-y divide-zinc-800/70">{children}</tbody>
    </table>
  </div>
);

export const UnitScoresTable = ({ units }) => (
  <Panel title="Learning Unit scores" subtitle="Average quiz and assessment scores (attempts)" testId="insights-units-table">
    {!units.length ? <Empty>No Learning Units yet.</Empty> : (
      <Table head={['Learning Unit', 'Completed', 'Quiz', 'Assessment']}>
        {units.map((u) => (
          <tr key={u.activity_id} data-testid={`insights-unit-row-${u.activity_id}`}>
            <td className="py-2 pr-3 text-zinc-200 max-w-[220px] truncate" title={u.title}>{u.title}</td>
            <td className="py-2 text-right text-zinc-400 tabular-nums">{u.completed}</td>
            <td className="py-2 text-right tabular-nums"><Score v={u.avg_quiz} n={u.quiz_attempts} /></td>
            <td className="py-2 text-right tabular-nums"><Score v={u.avg_assessment} n={u.assessment_attempts} /></td>
          </tr>
        ))}
      </Table>
    )}
  </Panel>
);

export const LabBadgesTable = ({ labs }) => (
  <Panel title="Navigate badges by lab" subtitle="Badges are awarded at 50%+" testId="insights-labs-table">
    {!labs.length ? <Empty>No Learning Labs yet.</Empty> : (
      <Table head={['Learning Lab', 'Completed', 'Badges', 'Avg score']}>
        {labs.map((l) => (
          <tr key={l.activity_id} data-testid={`insights-lab-row-${l.activity_id}`}>
            <td className="py-2 pr-3 text-zinc-200 max-w-[220px] truncate" title={l.title}>{l.title}</td>
            <td className="py-2 text-right text-zinc-400 tabular-nums">{l.completed}</td>
            <td className="py-2 text-right tabular-nums text-amber-300"><span className="inline-flex items-center gap-1"><Award className="h-3.5 w-3.5" />{l.badges}</span></td>
            <td className="py-2 text-right tabular-nums"><Score v={l.avg_score} n={l.badges} /></td>
          </tr>
        ))}
      </Table>
    )}
  </Panel>
);
